import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AuditConfigInput } from './audit-config-constants';
import {
  deleteCopyTigerAuditConfig,
  getCopyTigerAuditConfigs,
  saveCopyTigerAuditConfig
} from './copyTigerUtils';

const auditConfigsKey = (company: string) => ['copytiger-audit-configs', company];

export const useAuditConfigs = (company: string) =>
  useQuery({
    queryKey: auditConfigsKey(company),
    queryFn: () => getCopyTigerAuditConfigs(company),
    enabled: Boolean(company)
  });

export const useSaveAuditConfig = (company: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (config: AuditConfigInput) => saveCopyTigerAuditConfig(company, config),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: auditConfigsKey(company) })
  });
};

export const useDeleteAuditConfig = (company: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (configID: string) => deleteCopyTigerAuditConfig(company, configID),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: auditConfigsKey(company) })
  });
};
